/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { List } from '../fn/metric-library/list';
import { List$Params } from '../fn/metric-library/list';
import { MetricDefinitionModel } from '../models/metric-definition-model';
import { Save } from '../fn/metric-library/save';
import { Save$Params } from '../fn/metric-library/save';

@Injectable({ providedIn: 'root' })
export class MetricLibraryApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMetricLibraryListGet()` */
  static readonly ApiMetricLibraryListGetPath = '/api/MetricLibrary/List';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `List()` instead.
   *
   * This method doesn't expect any request body.
   */
  List$Response(params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MetricDefinitionModel>>> {
    return List(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `List$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  List(params?: List$Params, context?: HttpContext): Observable<Array<MetricDefinitionModel>> {
    return this.List$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MetricDefinitionModel>>): Array<MetricDefinitionModel> => r.body)
    );
  }

  /** Path part for operation `apiMetricLibrarySavePost()` */
  static readonly ApiMetricLibrarySavePostPath = '/api/MetricLibrary/Save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Save()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save$Response(params?: Save$Params, context?: HttpContext): Observable<StrictHttpResponse<MetricDefinitionModel>> {
    return Save(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Save$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save(params?: Save$Params, context?: HttpContext): Observable<MetricDefinitionModel> {
    return this.Save$Response(params, context).pipe(
      map((r: StrictHttpResponse<MetricDefinitionModel>): MetricDefinitionModel => r.body)
    );
  }

}
